import * as React from "react";

import {
  PolicyCancellationSuccessPage,
  PolicyCancellationSummaryPage,
} from "./pages/ConfirmPolicyCancelPage";
import { PolicyCancellationFlowPage } from "./pages/PolicyCancellationFlowPage";
import { Router, useNavigate } from "@reach/router";

import { ActivePolicyPage } from "./pages/ActivePolicyPage";
import { AppLayoutType } from "kw/components/AppLayout/AppLayout";
import { AutoUpdate } from "./pages/AutoUpdate";
import { ConfirmUpdatePolicyPage } from "kw/policies/pages/ConfirmUpdatePolicyPage";
import { Error404Page } from "kw/quoting/pages/Error404Page";
import { PolicyHolderFlowPage } from "kw/quoting/pages/PolicyHolderFlowPage";
import { PolicyListingPage } from "./pages/PolicyListingPage";
import { PolicyPage } from "./pages/PolicyPage";
import { PolicyUpdateFlowPage } from "kw/policies/pages/PolicyUpdateFlowPage";
import { RouterOutlet } from "kw/components/RouterOutlet/RouterOutlet";
import { UpdatePolicyKnockoutFlowPage } from "./pages/UpdatePolicyKnockoutFlowPage";
import { UpdatePolicyPage } from "./pages/UpdatePolicyPage";
import { UpdatePolicyReferralPage } from "./pages/UpdatePolicyReferralPage";
import { PolicyPaymentMethodPage } from "./pages/PolicyPaymentMethodPage";
import { PolicyCancellationPage } from "./pages/PolicyCancellationPage";

export function PoliciesMain() {
  const navigate = useNavigate();
  const policyPageBackNavigation = React.useCallback(() => {
    navigate("/policies");
  }, []);
  return (
    <Router basepath="/policies">
      <Error404Page default />
      <RouterOutlet
        component={PolicyListingPage}
        path="/"
        layoutOverrides={{
          showHeader: true,
          hideBackButton: true,
          headerText: "Policies",
          headerTextCenter: true,
        }}
      />
      <RouterOutlet component={ActivePolicyPage} path="active" />
      <RouterOutlet
        component={PolicyUpdateFlowPage}
        path=":policyId/update/start/*"
        isLegalPage={true}
      />
      <RouterOutlet
        component={UpdatePolicyReferralPage}
        path=":policyId/update/referral"
      />
      <RouterOutlet
        component={UpdatePolicyKnockoutFlowPage}
        path=":policyId/update/knockout/*"
      />
      <RouterOutlet
        component={PolicyHolderFlowPage}
        path=":policyId/update/details/policy_holder/*"
      />
      <RouterOutlet component={AutoUpdate} path="/autoupdate/*" />
      <RouterOutlet
        component={PolicyUpdateFlowPage}
        path=":policyId/update/details/*"
      />
      <RouterOutlet
        component={UpdatePolicyPage}
        path=":policyId/update/*"
        layoutOverrides={{
          showHeader: true,
          headerText: "Policy Details",
          headerTextCenter: true,
        }}
      />
      <RouterOutlet
        component={PolicyPage}
        path=":policyId/*"
        layoutOverrides={{
          showHeader: true,
          headerText: "Policy Details",
          headerTextCenter: true,
          backButtonClick: policyPageBackNavigation,
        }}
      />
      <RouterOutlet
        component={PolicyCancellationPage}
        path=":policyId/cancel"
        layoutOverrides={{
          showHeader: true,
          headerText: "Policy Cancellation",
          headerTextCenter: true,
        }}
      />
      <RouterOutlet
        component={PolicyCancellationFlowPage}
        path=":policyId/cancel/start/*"
        layoutOverrides={{
          showHeader: true,
          headerText: "Policy Cancellation",
          headerTextCenter: true,
        }}
      />
      <RouterOutlet
        component={PolicyCancellationSummaryPage}
        path=":policyId/cancel/confirm"
        layoutOverrides={{
          showHeader: true,
          headerText: "Policy Cancellation",
          headerTextCenter: true,
        }}
      />
      <RouterOutlet
        component={PolicyCancellationSuccessPage}
        path=":policyId/cancel/success"
        layoutOverrides={{
          showHeader: true,
          hideBackButton: true,
          headerText: "Policy Cancelled",
          headerTextCenter: true,
        }}
      />
      <RouterOutlet
        component={ConfirmUpdatePolicyPage}
        path=":policyId/update/confirm"
        layoutOverrides={{
          hideBackButton: true,
          layoutType: AppLayoutType.Portal,
        }}
      />
      <RouterOutlet
        component={PolicyPaymentMethodPage}
        path=":policyId/payment-method"
        layoutOverrides={{
          hideBackButton: true,
          layoutType: AppLayoutType.Portal,
        }}
      />
    </Router>
  );
}
